import styled from '../../config/theme';

export const FieldContainer = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
`;
